
import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import Spinner from '../../components/ui/Spinner';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';

export default function PaymentScreen({ editingContext }) {
  const [order, setOrder] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await api.OrderProcedureAPI(
          editingContext.id,
          editingContext.customerId,
          editingContext.user
        );

        console.log('OrderProcedureAPI response:', response);

        const orderDetails = response?.Table?.[0];
        const modes = response?.Table1 || [];

        if (!orderDetails) {
          console.warn('Order details not found in Table.');
          return;
        }

        setOrder(orderDetails);

        const mappedPayments = modes.map(mode => ({
          mode: mode.Mode || mode.PaymentMode || 'Unknown',
          amount: '', // keep as empty string for inputs
          chqno: '',
          notes: ''
        }));

        setPayments(mappedPayments);
      } catch (error) {
        console.error('Error fetching payment data:', error);
      }
    };

    fetchOrder();
  }, [editingContext]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      for (let payment of payments) {
        const amountNum = parseFloat(payment.amount) || 0;
        if (amountNum > 0) {
          const payload = {
            SqlAction: 'Insert',
            Vid: editingContext.customerId,
            Amount: amountNum,
            Mode: payment.mode,
            Chqno: payment.chqno || '',
            Notes: payment.notes || '',
            User: editingContext.user,
            VrId: editingContext.id
          };

          console.log('Saving payment:', payload);

          const response = await fetch(
            'https://tradeservice.revampapps.com/SavePayment',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            }
          );

          if (!response.ok) {
            throw new Error(`Save failed: ${response.status}`);
          }

          const result = await response.json();
          console.log('SavePayment result:', result);
        }
      }

      alert('Payments saved successfully');
    } catch (error) {
      console.error('Error saving payments:', error);
      alert('Failed to save payments');
    } finally {
      setLoading(false);
    }
  };

  if (!order) return <Spinner />;

  const totalPaid = payments.reduce(
    (sum, p) => sum + (parseFloat(p.amount) || 0),
    0
  );
  const balance =
    (parseFloat(order.OrdValue) || 0) - (parseFloat(totalPaid) || 0);

  return (
    <div className="payment-container">
      <Card>
        <div className="payment-header">
          <label>Customer Name</label>
          <input readOnly value={`${order.vname}/ ${order.vcode}`} />

          <div className="grid-3">
            <div>
              <label>Order Value</label>
              <input readOnly value={order.OrdValue || 0} />
            </div>
            <div>
              <label>Balance</label>
              <input readOnly value={balance || 0} />
            </div>
            <div>
              <label>Total Payable</label>
              <input readOnly value={order.OrdValue || 0} />
            </div>
          </div>
        </div>

        <h3 className="section-title">Payment</h3>

        <div className="table-wrapper">
          <table className="payment-table">
            <thead>
              <tr>
                <th>Mode</th>
                <th>Amount</th>
                <th>Cheque No</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr key={index}>
                  <td>
                    <input type="text" value={payment.mode} readOnly />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={payment.amount}
                      onChange={(e) => {
                        const newPayments = [...payments];
                        newPayments[index].amount = e.target.value; // keep as string for controlled input
                        setPayments(newPayments);
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={payment.chqno}
                      onChange={(e) => {
                        const newPayments = [...payments];
                        newPayments[index].chqno = e.target.value;
                        setPayments(newPayments);
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={payment.notes}
                      onChange={(e) => {
                        const newPayments = [...payments];
                        newPayments[index].notes = e.target.value;
                        setPayments(newPayments);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="payment-summary">
          <div className="summary-row">
            <label>Total Paid</label>
            <span>{totalPaid}</span>
          </div>
          <div className="summary-row">
            <label>Balance</label>
            <span>{balance}</span>
          </div>
        </div>

        <Button onClick={handleSubmit} disabled={loading}>
          {loading ? 'Saving...' : 'Submit'}
        </Button>
      </Card>
    </div>
  );
}
